import { get } from "@/request/http";

// 获取实验列表
export { showVirtualSimulation } from "../../public/virtualExp";

// 获取实验数据列表
export const apiGetDataList = p => get("/exp/getExpDataList", p);
